import { defineMessages } from "react-intl";

const MERGE_ACCOUNTS_SECTION = "merge-accounts-section";

const mergeAccountsSectionMessages = defineMessages({
  mergeDatafromAccount: {
    id: `${MERGE_ACCOUNTS_SECTION}.merge-data-from-account`,
    defaultMessage:
      "Merge account data from one EBSCO account with another. Take searches, videos, pages and more with you. <getStartedLink>Get started.</getStartedLink> "
  }
});

export default mergeAccountsSectionMessages;
